














import { Vue, Component } from 'vue-property-decorator'
import Fullscreen from "@/components/Fullscreen/index.vue";
import Frame from "./Frame/index.vue"
import { StyleFactory } from '@hscmap/vue-menu';
import { AsyncAlertRoot } from "@/galaxy-cruise/components/AsyncAlert";
import ModalSpinner from "@/galaxy-cruise/components/ModalSpinner.vue";
import { spinner } from "@/galaxy-cruise/spinner"

@Component({
  components: { Fullscreen, Frame, AsyncAlertRoot, ModalSpinner },
})
export default class extends Vue {
  get loading() {
    return spinner.loading
  }
}
